<div
  class="centered">
  <coa-show-all (click)="showAllGroups()"></coa-show-all>
</div>
